import { render, staticRenderFns } from "./template_list.vue?vue&type=template&id=522c2d0d&scoped=true&"
import script from "./template_list.vue?vue&type=script&lang=js&"
export * from "./template_list.vue?vue&type=script&lang=js&"
import style0 from "./template_list.vue?vue&type=style&index=0&id=522c2d0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522c2d0d",
  null
  
)

export default component.exports